import { NgModule } from '@angular/core';
import { Ng2Cable } from './ng2-cable';
import { Broadcaster } from './broadcaster';



export class Ng2CableModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  providers: [
    Ng2Cable,
    Broadcaster
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
